"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InspectionType = exports.InspectionStatus = void 0;
/**
 * Status of an inspection.
 *
 * *Swagger Schema Reference :* `InspectionStatus`
 */
var InspectionStatus;
(function (InspectionStatus) {
    /**
     * Indicates that the inspection has not been started by the server and is waiting for more data.
     */
    InspectionStatus["NOT_STARTED"] = "NOT_STARTED";
    /**
     * Indicates that the server has started processing the inspection,
     */
    InspectionStatus["IN_PROGRESS"] = "IN_PROGRESS";
    /**
     * Indicates that the server has successfully completed the inspection.
     */
    InspectionStatus["DONE"] = "DONE";
    /**
     * Indicates that an error occurred during the inspection.
     */
    InspectionStatus["ERROR"] = "ERROR";
    /**
     * Indicates that the server has successfully completed the inspection and that an external resource has validated the
     * inspection.
     */
    InspectionStatus["VALIDATED"] = "VALIDATED";
})(InspectionStatus = exports.InspectionStatus || (exports.InspectionStatus = {}));
/**
 * The different types of inspection.
 *
 * *Swagger Schema Reference :* `InspectionType`
 */
var InspectionType;
(function (InspectionType) {
    /**
     * The claiming of a car.
     */
    InspectionType["CLAIM"] = "claim";
    /**
     * Inspection of the car condition during a check in or check out (renting etc...).
     */
    InspectionType["CHECK_IN_CHECK_OUT"] = "check_in_check_out";
})(InspectionType = exports.InspectionType || (exports.InspectionType = {}));
//# sourceMappingURL=entityTypes.js.map